<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-40"></menubar>
    </div>
    <!--  左メニュー 終了 -->

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("label.system.userGroup.search.title") }}</label>
        <narrow-down
          v-auth="{ auth: '010702' }"
          @click="createUserGroup"
          slot="create">
          {{ $t("label.system.userGroup.search.userGroupCreate") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <!--   検索エリア 開始   -->
      <div class="panel-search">
        <el-form
          :rules="rules"
          :model="query"
          ref="ruleForm"
          class="search-form"
          label-position="left"
        >
          <div class="fm-row">
            <el-form-item prop="ownerExId">
              <el-input
                maxlength="20"
                v-model="query.ownerExId"
                class="fm-input"
                :placeholder="$t('label.common.ownerIdPlaceHolderPortion')"
              >
              </el-input>
            </el-form-item>
            <!-- オーナー名 -->
            <sp-smartLable-button class="fm-lb-btn line-limit-length" v-show="query.ownerName">
              {{ query.ownerName }}
            </sp-smartLable-button>
            <button-index
              class="fm-st-btn limit-length"
              @click="searchOwnerPopup">
              {{ $t("button.common.select") }}
            </button-index>
          </div>

          <div class="fm-row">
            <!-- ビルID -->
            <el-form-item prop="buildingExId">
              <el-input
                maxlength="20"
                v-model="query.buildingExId"
                class="fm-input"
                :placeholder="$t('label.common.buildingIdPlaceHolderPortion')">
              </el-input>
            </el-form-item>
            <!-- ビル名 -->
            <sp-smartLable-button class="fm-lb-btn line-limit-length" v-show="query.buildingName">
              {{ query.buildingName }}
            </sp-smartLable-button>
            <button-index
              class="fm-st-btn limit-length"
              @click="searchBuildingPopup">
              {{ $t("button.common.select") }}
            </button-index>
          </div>

          <div class="fm-row">
            <!-- テナントID -->
            <el-form-item prop="tenantExId">
              <el-input
                maxlength="20"
                v-model="query.tenantExId"
                class="fm-input"
                :placeholder="$t('label.common.tenantIdPlaceHolderPortion')">
              </el-input>
            </el-form-item>
            <!-- テナント名 -->
            <sp-smartLable-button class="fm-lb-btn line-limit-length" v-show="query.tenantName">
              {{ query.tenantName }}
            </sp-smartLable-button>
            <button-index
              class="fm-st-btn limit-length"
              @click="searchTenantPopup">
              {{ $t("button.common.select") }}
            </button-index>
          </div>

          <div class="fm-row">
            <!-- フロア選択 -->
            <el-form-item>
              <el-input
                :readonly="true"
                clearable
                maxlength="50"
                class="fm-input"
                v-model="query.floorName"
                :placeholder="$t('label.system.account.search.floorSearch')"
              >
              </el-input>
            </el-form-item>
            <button-index
              class="fm-st-btn limit-length"
              @click="searchFloorPopup">
              {{ $t("button.common.select") }}
            </button-index>
          </div>

          <div class="fm-row">
            <!-- エリア選択 -->
            <el-form-item>
              <el-input
                :readonly="true"
                clearable
                maxlength="50"
                class="fm-input"
                v-model="query.areaName"
                :placeholder="$t('label.system.account.search.areaSelect')"
              >
              </el-input>
            </el-form-item>
            <button-index
              class="fm-st-btn limit-length"
              @click="searchAreaPopup">
              {{ $t("button.common.select") }}
            </button-index>
          </div>

          <div class="fm-row">
            <!-- ユーザーグループID -->
            <el-form-item>
              <el-input
                :clearable="false"
                maxlength="20"
                class="fm-input"
                v-model="query.userGroupExId"
                :placeholder="$t('label.common.userGroupExId')"
              />
            </el-form-item>
          </div>

          <div class="fm-row">
            <!-- ユーザーグループ名 -->
            <el-form-item prop="fullname">
              <el-input
                :clearable="false"
                maxlength="50"
                class="fm-input"
                v-model="query.userGroupName"
                :placeholder="$t('label.common.userGroupPlaceHoder')"
              />
            </el-form-item>
          </div>

          <div class="fm-row">
            <!-- メールアドレス -->
            <el-form-item>
              <el-input
                :clearable="false"
                maxlength="319"
                class="fm-input"
                v-model="query.userKeyword"
                :placeholder="$t('label.common.memberNameEmailAddressPlaceHolder')"
              />
            </el-form-item>
          </div>

          <div class="fm-row btn-area">
            <narrowDown @click="searchUserGroup">
              {{$t("button.common.narrow") }}
            </narrowDown>
            <cancelNarrowDown class="link-primary margin-left-8" @click="clearUserGroup">
              {{ $t("button.common.cancelNarrow") }}
            </cancelNarrowDown
            >
          </div>
        </el-form>
      </div>
      <!--   検索エリア 終了   -->

      <label v-show="isShow" class="list-title">{{ $t("label.system.userGroup.search.userGroupList") }}</label>
      <div class="st-page-size" v-show="isShow">
        <label class="lable-right-16">{{ $t("label.common.count") }}</label>
        <el-select v-model="query.pageSize" @change="handleChangePageSize">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <!--  検索結果表示 開始  -->
      <div ref="searchResultTable" id="manage-account-searce-result" class="m-bottom-8 margin-top-28">
        <user-group-search-result-beautify
          :isShow="isShow"
          v-if="this.isShow"
          :result="searchResult.body"
          @om-delete="deleteUserGroup"
        />
      </div>
      <!--  検索結果表示 終了  -->

      <!--   ページャー   -->
      <pagination
        v-show="isShow"
        :totalCount="searchResult.totalCount"
        :totalPage="searchResult.totalPage"
        :pageSize="query.pageSize"
        :pageNumber="searchResult.pageNumber"
        @on-paging="handlePagingAction"
      />

      <!-- オーナー選択子画面 -->
      <owner-search-popup
        :ownerExIdParam="query.ownerExId"
        :ownerNameParam="query.ownerName"
        :visible.sync="ownerSearchFlg"
        @on-selected="getOwnerInfo"
      />

      <!-- テナント選択子画面 -->
      <tenant-search-popup
        :tenantName="query.tenantName"
        :tenantEXId="query.tenantExId"
        :ownerId="query.ownerId"
        :buildingId="query.buildingId"
        :visible.sync="tenantSearchFlg"
        @on-selected="getTenantInfo"
      />

      <!-- ビル選択子画面 -->
      <building-search-popup
        :ownerIdParam="query.ownerId"
        :buildingExIdParam="query.buildingExId"
        :buildingNameParam="query.buildingName"
        :visible.sync="buildingSearchFlg"
        @on-selected="getBuildingInfo"
      />

      <floor-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorNameParam="query.floorName"
        :visible.sync="floorSearchFlg"
        @on-selected="getFloorInfo" />

      <area-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorIdParam="query.floorId"
        :areaNameParam="query.areaName"
        :visible.sync="areaSearchFlg"
        @on-selected="getAreaInfo">
      </area-search-popup>

    </div>
  </main-layout>
</template>

<script>
import NewDesignLayout from "@/layout/NewDesignLayout";
import Pagination from "@/components/common/pagination/Pagination";
import SystemManageApi from "@/api/SystemManageApi";
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup";
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup";
import FloorSearchPopup from "@/components/system/popup/FloorSearchPopup";
import TenantSearchPopup from "@/components/system/popup/TenantSearchPopup";
import AreaSearchPopup from "@/components/system/popup/AreaSearchPopup";
import userGroupSearchRulesFactory from "@/rules/rule-user-group-search";
import UserGroupSearchResultBeautify from "@/components/system/UserGroupSearchResultBeautify";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import headTitle from "@/components/common/head/head";
import SpSmartLableButton from "@/components/common/sp-smart-lable-button";
import buttonIndex from "@/components/common/sp-smart-button/index";
import statusErrorCodeMsg from "@/utils/status-error-msg"

export default {
  name: "AccountSearch",
  components: {
    MainLayout: NewDesignLayout,
    Pagination: Pagination,
    OwnerSearchPopup: OwnerSearchPopup,
    BuildingSearchPopup: BuildingSearchPopup,
    UserGroupSearchResultBeautify: UserGroupSearchResultBeautify,
    narrowDown: narrowDown,
    cancelNarrowDown: cancelNarrowDown,
    TenantSearchPopup: TenantSearchPopup,
    Menubar: Menubar,
    headTitle: headTitle,
    SpSmartLableButton: SpSmartLableButton,
    FloorSearchPopup: FloorSearchPopup,
    AreaSearchPopup: AreaSearchPopup,
    buttonIndex
  },
  data() {
    return {
      isShow: false,
      isSearching: false,
      tableLoadingAnim: null,
      rules: userGroupSearchRulesFactory.userGroupSearchRules(this),
      ownerSearchFlg: false,
      accountLockFlg: false,
      tenantSearchFlg: false,
      buildingSearchFlg: false,
      floorSearchFlg:false,
      areaSearchFlg:false,
      options: [
        {
          label: "10件",
          value: 10,
        },
        {
          label: "20件",
          value: 20,
        },
        {
          label: "50件",
          value: 50,
        },
      ],
      account: {
        accountId: null,
        userName: null,
        tenantName: null,
        lockDatetime: null,
        lockStatus: null,
      },

      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        tenantId: null,
        tenantExId: null,
        tenantName: null,
        accountType: null,
        role: null,
        lockStatus: null,
        fullname: null,
        email: null,
        pageNumber: 1,
        pageSize: 10,
        userGroupExId:null,
      },

      searchResult: {
        totalCount: 0,
        totalPage: 0,
        pageSize: 10,
        pageNumber: 1,
        body: [
          {
            accountId: null,
            accountExId: null,
            fullname: null,
            email: null,
            accountType: null,
            ownerName: null,
            ownerId: null,
            ownerExId: null,
            tenantId: null,
            tenantExId: null,
            tenantName: null,
            lockStatusCode: null,
            lockDatetime: null,
          },
        ],
      },
      role:[],
      accountType: [],
      blankTypeArr: [
        {
          value: null,
          type: "",
        }
      ],
    };
  },
  watch: {
    query: {
      handler() {
        this.query.pageNumber = 1
      },
      deep: true
    }
  },
  mounted() {
    let queryObj = this.$getQueryParam("user_group_search_id")
    if(queryObj!=null){
      this.query = queryObj
      this.doneSearchUserGroup();
      this.isShow = true
    }
  },
  created() {
    this.$authCheck("010101");
    this.searchResult.body = [];
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "",
        title: "label.menu.UserGroup",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  methods: {

    handleChangePageSizes(val) {
      this.query.pageSize = val;
      this.doneSearchUserGroup();
    },
    handleChangePageSize() {
      this.query.pageNumber = 1
      this.doneSearchUserGroup();
    },

    /**
     * 调用 テナント選択 子画面
     */
    searchTenantPopup() {
      this.tenantSearchFlg = true;
    },

    /**
     * ユーザーグループ新規
     */
    createUserGroup() {
      this.$saveQueryParam("user_group_search_id", this.query)
      this.$router.push({
        name: "system-user-group-create",
      });
    },

    /**
     * ユーザー検索条件チェック
     */
    searchUserGroup() {
      this.$saveQueryParam("user_group_search_id", this.query)
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.doneSearchUserGroup();
          this.isShow = true;
        }
      });
    },

    deleteUserGroup(userGroupId) {
    this.showTableLoadingAnim();
    SystemManageApi.deleteUserGroup(userGroupId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if (!statusErrorCodeMsg(data.statusCode, this)) {
          this.showLoading = false
          return;
        }
        this.deleteSuccess()
      }).finally(()=>{
        this.hideTableLoadingAnim();
        this.searchUserGroup()
      })
    },

    /**
     * ユーザーグループ検索
     */
    doneSearchUserGroup() {
      this.showTableLoadingAnim();
      if (!this.isSearching) {
        SystemManageApi.searchUserGroup({
          ownerId: this.query.ownerId,
          ownerExId: this.query.ownerExId,
          ownerName: this.query.ownerName,
          buildingId: this.query.buildingId,
          buildingExId: this.query.buildingExId,
          buildingName: this.query.buildingName,
          tenantId: this.query.tenantId,
          tenantExId: this.query.tenantExId,
          tenantName: this.query.tenantName,
          floorId: this.query.floorId,
          areaId: this.query.areaId,
          userGroupName: this.query.userGroupName,
          userKeyword: this.query.userKeyword,
          userGroupExId: this.query.userGroupExId,
          pageNumber: this.query.pageNumber,
          pageSize: this.query.pageSize,
        })
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            if (!statusErrorCodeMsg(data.statusCode, this)) {
              return;
            }
            this.searchResult.totalCount = data.body.totalCount;
            this.searchResult.totalPage = data.body.totalPage;
            this.query.pageSize = data.body.pageSize;
            this.searchResult.pageNumber = data.body.pageNumber;

            this.searchResult.body = [];
            for (let content of data.body.body) {
              this.searchResult.body.push({
                userGroupId: content.userGroupId,
                userGroupExId: content.userGroupExId,
                userGroupName: content.userGroupName,
                ownerId: content.ownerId,
                ownerExId: content.ownerExId,
                ownerName: content.ownerName,
                tenantId: content.tenantId,
                tenantName: content.tenantName,
                tenantExId: content.tenantExId,
                accountList: content.accountList,
                areaList: content.areaList,
                deleteFlag: content.deleteFlag,
              });
            }
          })
          .finally(() => {
            this.isSearching = false;
            this.hideTableLoadingAnim();
          });
      }
    },

    /**
     * 获取 テナント選択 子画面的值
     */
    getTenantInfo(tenant) {
      if (this.query.tenantId != tenant.tenantId) {
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = tenant.ownerId;
      this.query.ownerExId = tenant.ownerExId;
      this.query.ownerName = tenant.ownerName;
      this.query.tenantId = tenant.tenantId;
      this.query.tenantExId = tenant.tenantExId;
      this.query.tenantName = tenant.tenantName;
    },

    /**
     * 検索条件クリア
     */
    clearUserGroup() {
      this.$saveQueryParam("user_group_search_id", null)
      this.query.ownerId = null;
      this.query.ownerExId = null;
      this.query.ownerName = null;
      this.query.buildingId = null;
      this.query.buildingExId = null;
      this.query.buildingName = null;
      this.query.tenantExId = null;
      this.query.tenantId = null;
      this.query.floorId = null;
      this.query.floorName = null;
      this.query.areaName = null;
      this.query.tenantName = null;
      this.query.role = null;
      this.query.accountType = null;
      this.query.fullname = null;
      this.query.lockStatus = null;
      this.query.email = null;
      this.query.areaId = null;
      this.query.userGroupName = null;
      this.query.userKeyword = null;
      this.searchResult.body = [];
      this.query.userGroupExId = null;
      this.isShow = false;
    },

    /**
     * ページャーイベント
     */
    handlePagingAction(pagination) {
      this.query.pageNumber = pagination.pageNumber;
      this.query.pageSize = pagination.pageSize;
      this.searchUserGroup();
      this.$refs.searchResultTable.scrollIntoView()
    },

    /**
     * アカウント情画面に遷移
     */
    detailAccount(accountId) {
      this.$saveQueryParam("user_group_search_id", this.query)
      this.$router.push({
        name: "system-account-detail",
        params: {
          accountId: accountId,
        },
      });
    },

    deleteSuccess() {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: this.$t("label.system.userGroup.search.title"),
      }));
    },

    /**
     * ローディング動画表示
     */
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#manage-account-searce-result",
          background: "#ebebe6"
        });
      }
    },

    /**
     * ローディング動画隠す
     */
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },

    /**
     * オーナー選択画面表示処理を呼び出す
     */
    searchOwnerPopup() {
      this.ownerSearchFlg = true;
    },

    /**
     * オーナー選択の値を取得
     */
    getOwnerInfo(owner) {
      if (this.query.ownerId != owner.id) {
        this.query.buildingName = null;
        this.query.buildingExId = null;
        this.query.buildingId = null;
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
        this.query.tenantId = null;
        this.query.tenantExId = null;
        this.query.tenantName = null;
      }
      this.query.ownerId = owner.id;
      this.query.ownerExId = owner.exId;
      this.query.ownerName = owner.name;
    },

    /**
     * ビル選択画面表示処理を呼び出す
     */
    searchBuildingPopup() {
      this.buildingSearchFlg = true;
    },

    searchFloorPopup() {
      this.floorSearchFlg = true;
    },

    getFloorInfo(floor) {
      if (this.query.floorId != floor.floorId) {
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.floorId = floor.floorId
      this.query.floorName = floor.floorName
      this.query.ownerId = floor.ownerId
      this.query.ownerName = floor.ownerName
      this.query.ownerExId = floor.ownerExId
      this.query.buildingId = floor.buildingId
      this.query.buildingName = floor.buildingName
      this.query.buildingExId = floor.buildingExId
    },

    searchAreaPopup() {
      this.areaSearchFlg = true;
    },

    getAreaInfo(area) {
      this.query.areaId	= area.areaId
      this.query.areaName	= area.areaName
      this.query.areaType	= area.areaType
      this.query.ownerId = area.ownerId
      this.query.ownerExId = area.ownerExId
      this.query.ownerName = area.ownerName
      this.query.buildingId	= area.buildingId
      this.query.buildingExId	= area.buildingExId
      this.query.buildingName	= area.buildingName
      this.query.floorId = area.floorId
      this.query.floorName = area.floorName
    },

    /**
     * ビル選択子画面の値を取得
     */
    getBuildingInfo(building) {
      if (this.query.buildingId != building.buildingId) {
        this.query.tenantId = null;
        this.query.tenantExId = null;
        this.query.tenantName = null;
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = building.ownerId;
      this.query.ownerExId = building.ownerExId;
      this.query.ownerName = building.ownerName;
      this.query.buildingId = building.buildingId;
      this.query.buildingExId = building.buildingExId;
      this.query.buildingName = building.buildingName;
    },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .cancel-width{
  .my-button{
    height: 32px;
  }
}

::v-deep .st-page-size label{
    top: 0px;
  }

.limit-length {
   width: 100px !important;
}
</style>
